import React from 'react';
import { OriginBadge } from './OriginBadge';
import { formatMomentDate, formatMomentTime, monthKey } from '../../../utils/momentDates';

const summary = (attachments = []) => {
  const n = (k) => attachments.filter((a) => a.kind === k).length;
  return [
    n('photo') && `${n('photo')} photo${n('photo') > 1 ? 's' : ''}`,
    n('audio') && `${n('audio')} recording${n('audio') > 1 ? 's' : ''}`,
    n('file') && `${n('file')} file${n('file') > 1 ? 's' : ''}`
  ].filter(Boolean).join(' · ');
};

export const MomentTimeline = ({ moments, onOpen }) => {
  const groups = [];
  moments.forEach((m) => {
    const key = monthKey(m.occurred_at);
    const last = groups[groups.length - 1];
    if (last && last.key === key) last.items.push(m);
    else groups.push({ key, items: [m] });
  });

  return (
    <div className="space-y-8">
      {groups.map((g) => (
        <section key={g.key}>
          <h2 className="text-sm font-bold uppercase tracking-wider text-slate-400 mb-4">{g.key}</h2>
          <div className="relative pl-6 border-l-2 border-slate-100 space-y-4">
            {g.items.map((m) => (
              <button
                key={m.id}
                onClick={() => onOpen(m)}
                className="relative block w-full text-left bg-white rounded-2xl border border-slate-200/60 p-5 shadow-sm hover:shadow-md hover:border-slate-300 transition-all"
              >
                <span className="absolute -left-[31px] top-6 w-3 h-3 rounded-full bg-slate-900 ring-4 ring-[#FAFAFA]" />
                <p className="text-xs font-medium text-slate-400">
                  {formatMomentDate(m.occurred_at)} · {formatMomentTime(m.occurred_at)}
                </p>
                {m.title && <h3 className="mt-1 text-lg font-bold text-slate-900 tracking-tight break-words">{m.title}</h3>}
                {m.body && <p className="mt-1 text-[15px] text-slate-600 line-clamp-3 whitespace-pre-wrap break-words">{m.body}</p>}
                <OriginBadge moment={m} className="mt-2" />
                {m.attachments?.length > 0 && (
                  <p className="mt-2 text-xs font-semibold text-slate-400">{summary(m.attachments)}</p>
                )}
                {m.people?.length > 0 && (
                  <p className="mt-3 text-xs font-semibold text-slate-500 break-words">
                    With {m.people.map((p) => p.full_name || 'Contact').join(', ')}
                  </p>
                )}
              </button>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};